import { render, staticRenderFns } from "./SelectOfUsersByRole.vue?vue&type=template&id=2740a447&"
import script from "./SelectOfUsersByRole.vue?vue&type=script&lang=js&"
export * from "./SelectOfUsersByRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports